// extracted by mini-css-extract-plugin
export var infoItem = "_ty-2";
export var title = "_ty-0";
export var value = "_ty-1";